export default "__VITE_ASSET__BX23Dnp0__"